import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const checkTenantHubspot = async (tenantHandle) => {
  return api.get(`/api/${tenantHandle}/hubspot/check`);
};

export const getHubspotOauthUrl = async (tenantHandle) => {
  return api.get(`/${tenantHandle}/oauth`);
};

export const disconnectHubspot = async (tenantHandle) => {
  return api.create(`/api/${tenantHandle}/hubspot/disconnect`);
};
